function Spinner({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      className={className}
      width="112"
      height="112"
      viewBox="0 0 112 112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="56" cy="56" r="54" stroke="#EEEEEE" strokeWidth="4" />
      <mask
        id="mask0_16005_11314"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="56"
        height="56"
      >
        <path
          d="M0 56C6.4291e-07 48.646 1.44848 41.364 4.26275 34.5697C7.07702 27.7755 11.2019 21.6021 16.402 16.402C21.6021 11.2019 27.7755 7.077 34.5697 4.26274C41.364 1.44848 48.646 -3.59436e-06 56 0L56 56L0 56Z"
          fill="#04709B"
        />
      </mask>
      <g mask="url(#mask0_16005_11314)">
        <circle cx="56" cy="56" r="54" stroke="#04709B" strokeWidth="4" />
      </g>
    </svg>
  );
}

export default Spinner;
